// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-container {
  display: flex;
  flex-direction: column;
}
.services-container h1 {
  padding-left: 20px;
}
.services-container .disabled-color {
  color: #b0b0b0 !important;
  cursor: not-allowed !important;
}
.services-container .services-content {
  flex-direction: column;
  padding: 20px 20px 20px 8px;
}
.services-container .services-content .blocks-container {
  justify-content: left !important;
  margin-bottom: 25px !important;
}
.services-container .services-content .blocks-container a {
  text-decoration: none;
  color: black;
  width: 100% !important;
}
.services-container .services-content .blocks-container .app-block {
  min-width: 100% !important;
}
.services-container .services-content .blocks-container .blocks {
  border-radius: 5px;
  background: #f5f5f5;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 90% !important;
  height: 180px !important;
  margin: 16px !important;
  padding: 5px 15px 0 15px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: 1px solid transparent;
  cursor: pointer !important;
}
.services-container .services-content .blocks-container .blocks .app-info {
  display: flex;
  align-items: center;
}
.services-container .services-content .blocks-container .blocks .image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 42px !important;
  height: 42px !important;
  border-radius: 50%;
  font-size: 0.9em;
}
.services-container .services-content .blocks-container .blocks .image-container img {
  height: 18px;
  width: 18px;
}
.services-container .services-content .blocks-container .blocks .app-name {
  font-size: 14px;
  padding-left: 10px;
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.services-container .services-content .blocks-container .blocks .app-name h4 {
  font-family: "ABBVoice-bold";
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.services-container .services-content .blocks-container .blocks .box-content {
  font-family: "ABBVoice-regular";
  align-items: center;
}
.services-container .services-content .blocks-container .blocks .box-content p {
  margin: 0 0 10px 0;
  font-size: 12px !important;
  text-align: left;
  margin-top: 20px;
  margin-left: 24px;
}
.services-container .services-content .blocks-container .blocks .app-link {
  display: flex;
  margin-left: auto;
  color: #3366ff;
  font-family: "ABBVoice-medium";
  font-size: 12px;
}
.services-container .services-content .blocks-container .blocks .app-link a {
  color: #3366ff;
  text-transform: uppercase;
  text-decoration: none;
}
.services-container .services-content .blocks-container .blocks:hover {
  background: rgba(51, 102, 255, 0.1607843137);
  border: 1px solid #2934ff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.services-container .menu-container {
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/services.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;AADF;AAEE;EACE,kBAAA;AAAJ;AAEE;EACE,yBAAA;EACA,8BAAA;AAAJ;AAEE;EACE,sBAAA;EACA,2BAAA;AAAJ;AACI;EACE,gCAAA;EACA,8BAAA;AACN;AACM;EACE,qBAAA;EACA,YAAA;EACA,sBAAA;AACR;AAEM;EACE,0BAAA;AAAR;AAGM;EACE,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,qBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;AADR;AAGQ;EACE,aAAA;EACA,mBAAA;AADV;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAFV;AAIU;EACE,YAAA;EACA,WAAA;AAFZ;AAMQ;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAJV;AAMU;EACE,4BAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AAJZ;AAQQ;EACE,+BAAA;EACA,mBAAA;AANV;AAQU;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AANZ;AAUQ;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;AARV;AASU;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAPZ;AAYM;EACE,4CAAA;EACA,yBAAA;EACA,+CAAA;AAVR;AAcE;EACE,YAAA;AAZJ","sourcesContent":["@import \"../../assets/variables/fonts.scss\";\n\n.services-container {\n  display: flex;\n  flex-direction: column;\n  h1 {\n    padding-left: 20px;\n  }\n  .disabled-color{\n    color: #b0b0b0 !important;\n    cursor: not-allowed !important;\n  }\n  .services-content {\n    flex-direction: column;\n    padding: 20px 20px 20px 8px;\n    .blocks-container {\n      justify-content: left !important;\n      margin-bottom: 25px !important;\n\n      a {\n        text-decoration: none;\n        color: black;\n        width: 100% !important;\n      }\n\n      .app-block {\n        min-width: 100% !important;\n      }\n\n      .blocks {\n        border-radius: 5px;\n        background: #f5f5f5;\n        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n        width: 90% !important;\n        height: 180px !important;\n        margin: 16px !important;\n        padding: 5px 15px 0 15px !important;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        border: 1px solid transparent;\n        cursor: pointer !important;\n\n        .app-info {\n          display: flex;\n          align-items: center;\n        }\n\n        .image-container {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background-color: white;\n          width: 42px !important;\n          height: 42px !important;\n          border-radius: 50%;\n          font-size: 0.9em;\n\n          img {\n            height: 18px;\n            width: 18px;\n          }\n        }\n\n        .app-name {\n          font-size: 14px;\n          padding-left: 10px;\n          white-space: nowrap;\n          width: 200px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n\n          h4 {\n            font-family: \"ABBVoice-bold\";\n            font-size: 14px;\n            padding: 0;\n            margin: 0;\n          }\n        }\n\n        .box-content {\n          font-family: \"ABBVoice-regular\";\n          align-items: center;\n\n          p {\n            margin: 0 0 10px 0;\n            font-size: 12px !important;\n            text-align: left;\n            margin-top: 20px;\n            margin-left: 24px;\n          }\n        }\n\n        .app-link {\n          display: flex;\n          margin-left: auto;\n          color: #3366ff;\n          font-family: \"ABBVoice-medium\";\n          font-size: 12px;\n          a {\n            color: #3366ff;\n            text-transform: uppercase;\n            text-decoration: none;\n          }\n        }\n      }\n\n      .blocks:hover {\n        background: #3366ff29;\n        border: 1px solid #2934ff;\n        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n      }\n    }\n  }\n  .menu-container {\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
